module.exports = __webpack_public_path__ + "img/transaction_intro_03@2x.1e971b74.png";